import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Crediblefootprint({ handleShow }) {
  return (
    <section
      className="credible_footprint p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center resp_order"
          >
            <StaticImage
              src="../../../images/location_new/uk-mobile/footprint_map.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={445}
              height={721}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              The Credible Footprint We’ve <span>Established in the UK</span>
            </h2>
            <p>
              Our app development services in the UK have driven success across
              various industries, establishing our strong reputation in the
              market. We deliver custom applications that surpass client
              expectations, significantly boosting their digital presence and
              business growth. Our track record of innovation and client
              achievements underscores our role as a trusted app development
              partner in the UK.
            </p>
            <button
              onClick={handleShow}
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Contact Us
            </button>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Crediblefootprint;
